import { BulkUpdateFieldType } from "components/BulkUpdateOptionalFieldsModal/types";
import { CheckBox } from "components/Form/FormikControls";
import InsuranceRate from "components/Form/FormikControls/InsuranceRate";
import { BranchSelect } from "components/Form/FormikControls/BranchSelect";
import { CollapseTitle } from "components/BulkUpdateOptionalFieldsModal/util";
import { UpdateInformation } from "components/BulkUpdateOptionalFieldsModal/UpdateInformationBase";
import { DebtorInsuranceCheckbox } from "components/Form/FormikControls/DebtorInsuranceCheckbox";
import {
  buildBusinessLabelPayload,
  BusinessLabelSelector,
} from "components/BulkUpdateOptionalFieldsModal/BusinessLabels";
import { UpdateInformationBusinessLabels } from "components/BulkUpdateOptionalFieldsModal/UpdateInformationBusinessLabels";

export const BusinessFields: BulkUpdateFieldType[] = [
  {
    fieldName: "isActive",
    Component: CheckBox,
    componentProps: {
      label: "Active",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "isVendor",
    Component: CheckBox,
    componentProps: {
      label: "Vendor",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "isTransporter",
    Component: CheckBox,
    componentProps: {
      label: "Transporter",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "isBuyer",
    Component: CheckBox,
    componentProps: {
      label: "Buyer",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "isPublished",
    Component: CheckBox,
    componentProps: {
      label: "Published",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "isMeatProcessorCommercialBuyer",
    Component: CheckBox,
    componentProps: {
      label: "Meat Processor",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "isTopBuyerSheep",
    Component: CheckBox,
    componentProps: {
      label: "Top Buyer Sheep",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "isTopBuyerCattle",
    Component: CheckBox,
    componentProps: {
      label: "Top Buyer Cattle",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "hasDebtorInsurance",
    Component: DebtorInsuranceCheckbox,
    componentProps: {
      label: "Debtor Insurance",
      name: "hasDebtorInsurance",
    },
    collapseTitle: CollapseTitle.FINANCE_AND_ACCOUNTING,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "isHobbyFarmer",
    Component: CheckBox,
    componentProps: {
      label: "Hobby Farmer",
    },
    collapseTitle: CollapseTitle.FINANCE_AND_ACCOUNTING,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "hasTransitInsuranceForSales",
    Component: InsuranceRate,
    componentProps: {
      label: "Transit Insurance",
      name: "transitInsuranceApplicationDefault",
    },
    updateFieldNames: [
      "hasTransitInsuranceForPurchases",
      "hasTransitInsuranceForSales",
    ],
    collapseTitle: CollapseTitle.FINANCE_AND_ACCOUNTING,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: false,
  },
  {
    fieldName: "removeLabels",
    Component: BusinessLabelSelector,
    componentProps: {},
    collapseTitle: CollapseTitle.BUSINESS_LABELS,
    UpdateInformationComponent: UpdateInformationBusinessLabels,
    emptyValue: null,
    buildPayload: buildBusinessLabelPayload,
  },
  {
    fieldName: "addLabels",
    Component: BusinessLabelSelector,
    componentProps: {},
    collapseTitle: CollapseTitle.BUSINESS_LABELS,
    UpdateInformationComponent: UpdateInformationBusinessLabels,
    emptyValue: null,
  },
];

export const DeploymentBusinessFields = [
  ...BusinessFields,
  {
    fieldName: "branchId",
    Component: BranchSelect,
    componentProps: {
      label: "Branch",
    },
    collapseTitle: CollapseTitle.GENERAL,
    UpdateInformationComponent: UpdateInformation,
    emptyValue: null,
  },
];
